import { SseEventType } from './sse-event-type.model';
import { runInInjectionContext } from '@angular/core';
import { SseEventBase } from './sse-event-base.model';

export class SseLogoutEvent extends SseEventBase {

  type: SseEventType = 'logout';
  onMessage = (event: MessageEvent<any>): void => {
    const resp = JSON.parse(event.data);

    if (resp.logout) {
      runInInjectionContext(this.injector, () => {
        this.ngZone.run(() => {
          this.data.clear();
          this.router.navigate(['/']);
        });
      });
    }
  }
}
